import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1606"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.151 3.319h1.812a.6.6 0 0 1 .599.599v2.046a.7.7 0 1 0 1.4 0V3.918a2 2 0 0 0-1.999-1.999h-1.88c-.229-.319-.586-.541-1.01-.541H6.492c-.424 0-.78.222-1.01.541H3.49a2 2 0 0 0-1.999 1.999v8.17a2 2 0 0 0 1.999 1.999h1.369a.7.7 0 1 0 0-1.4H3.49a.6.6 0 0 1-.599-.599v-8.17a.6.6 0 0 1 .599-.599h1.924c.22.377.611.641 1.078.641h2.581c.467.001.859-.264 1.078-.641z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M10.67 8.139c-1.732.616-2.665-.042-2.72-.083a.701.701 0 0 0-.868 1.099c.045.035.825.643 2.201.643.532 0 1.153-.091 1.855-.341 2.137-.758 3.104-.064 3.13-.045a.7.7 0 0 0 .892-1.078c-.154-.128-1.598-1.226-4.49-.195zm0 2.528c-1.732.615-2.665-.042-2.721-.083a.701.701 0 0 0-.868 1.099c.045.035.825.643 2.201.643.532 0 1.153-.091 1.855-.341 2.137-.76 3.104-.064 3.13-.045a.699.699 0 1 0 .892-1.078c-.153-.129-1.597-1.226-4.489-.195zm0 2.528c-1.732.615-2.665-.041-2.721-.083a.701.701 0 0 0-.868 1.099c.045.035.825.643 2.201.643.532 0 1.153-.091 1.855-.341 2.14-.761 3.104-.065 3.13-.046a.7.7 0 0 0 .892-1.078c-.153-.128-1.594-1.225-4.489-.194z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }